import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { JsonValueT, PatternSectionT } from '../../schema/index.js';

function imageDetails(item: JsonValueT): { url: string; alt: string } {
  if (typeof item === 'string') return { url: item, alt: '' };
  return { url: itemStr(item, 'url'), alt: itemStr(item, 'alt') };
}

/** gallery — image grid; accepts string URLs and {url, alt} items. */
export function renderGallery(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const images = list(section.fields, 'images')
    .map((item, index) => {
      const image = imageDetails(item);
      if (!image.url) return '';
      const imagePath = `/images/${index}`;
      return [
        `    <figure class="ve-gallery__item"${editAttr(section, imagePath)}>`,
        `      <img class="ve-gallery__image" src="${safeUrl(image.url)}" alt="${escapeHtml(image.alt)}">`,
        '    </figure>',
      ].join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'gallery', heading, label),
    itemCollection(section, 'div', 've-gallery__images', '/images', images),
    '</section>',
  ];
  return parts.join('\n');
}
